import React, { useEffect, useState } from "react";
import { getClientUrlDataToken, postDataWithToken } from "../../Utils/restUtils";
import { getCustomerReward, getRewardHistory, postRedeemPoints } from "../../CommonUrl";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Frame from '../../assets/images/RewardBG.svg';

const RedeemModal = ({ setisOpen, dashboard }) => {
    const [customerReward, setCustomerReward] = useState('');
    const [rewardPoint, setRewardPoints] = useState([]);
    const [page, setPage] = useState(1);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    useEffect(() => {
        fetchAccountData();
        fetchRewardData(page);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const bottomReached =
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;
            if (bottomReached && !isLoadingMore && hasMore) {
                setPage((prevPage) => prevPage + 1);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isLoadingMore, hasMore]);


    useEffect(() => {
        if (page !== 1) {
            fetchRewardData(page);
        }
    }, [page]);

    const fetchAccountData = async () => {
        // setLoading(true);
        const response = await getClientUrlDataToken(getCustomerReward);
        if (response?.status) {
            setCustomerReward(response.data);
        } else {
            setLoading(false);
        }
        // setLoading(false);
    }

    const fetchRewardData = async (pageNo = 1) => {
        if (!hasMore || isLoadingMore) return;
        setIsLoadingMore(true);
        try {
            const response = await getClientUrlDataToken(`${getRewardHistory}?page=${pageNo}`);
            if (response?.status && response?.data?.data?.length) {
                setRewardPoints((prev) => [...prev, ...response.data.data]);
                setHasMore(response.data.data.length === 50);
            } else {
                setHasMore(false);
            }
        } catch (err) {
            console.error("Error loading reward history", err);
            setHasMore(false);
        }

        setIsLoadingMore(false);
    };



    const handleAddToWallet = async () => {
        const response = await postDataWithToken(postRedeemPoints);
        if (response?.status === 200) {
            if (response?.data?.status === true) {
                dashboard();
                toast.success(response?.data?.message);
                setisOpen(false);
            } else {
                toast.error(response?.data?.message);
            }
        }
    };

    return (
        <div className="container mt-2" style={{ maxWidth: '600px', margin: '0 auto' }}>
            {/* Reward Points Card */}
            <div
                style={{
                    position: 'relative',
                    backgroundImage: `url(${Frame})`, // replace with your image
                    backgroundSize: 'cover',
                    backgroundPosition: 'left center',
                    borderRadius: '15px',
                    padding: '25px 30px',
                    height: '200px',
                    color: '#fff',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }}
            >
                <div style={{ fontSize: '14px', backgroundColor: 'rgba(255,255,255,0.2)', borderRadius: '10px', padding: '5px 12px', width: 'fit-content' }}>
                    Your Reward Points
                </div>

                <div>
                    <h1 style={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '5px' }}>{customerReward?.total_rewrd_points} Points</h1>
                    <div style={{ fontSize: '14px' }}>{customerReward?.redeem_points} Pts = B$1</div>
                </div>
            </div>

            {/* Redeem Button */}
            <div style={{
                backgroundColor: '#FFF8E1',
                color: '#B85C02',
                fontWeight: '500',
                fontSize: '18px',
                textAlign: 'center',
                borderRadius: '40px',
                marginTop: '20px',
                padding: '12px',
                width: '100%',
                cursor: 'pointer',
            }}
                onClick={handleAddToWallet}>
                Add To Wallet
            </div>

            {/* Points History Title */}
            <h5 className="mt-4 mb-3 fw-bold">Points History</h5>
            <div
                style={{
                    maxHeight: '200px', // or any height you want
                    overflowY: 'auto',
                    paddingRight: '10px',
                    marginTop: '20px'
                }}
            >
                {rewardPoint.map((val, index) => (
                    <div
                        key={index}
                        style={{
                            backgroundColor: '#fff',
                            borderRadius: '12px',
                            padding: '15px 20px',
                            marginBottom: '15px',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.05)'
                        }}
                    >
                        <div className="d-flex justify-content-between align-items-start">
                            <div className="d-flex gap-3">
                                <img src="/Services/RewardIcon.svg" alt="icon" width="24" />
                                <div>
                                    <div className="fw-bold">
                                        {val.action === "earned" ? "Points Earned" : "Points Redeemed"}
                                    </div>
                                    <div style={{ fontSize: '13px', color: '#555' }}>
                                        {val.action === "redeemed" && `$${val.redeem_amount} added to wallet`}
                                    </div>
                                </div>
                            </div>
                            <div className="text-end">
                                <div style={{ color: val.action === "earned" ? 'green' : '#6C63FF', fontWeight: '600' }}>
                                    {val.action === "earned" ? `+${val.points_earned} Pts` : `-${val.points_redeemed} Pts`}
                                </div>
                                <div style={{ fontSize: '12px', color: '#999' }}>
                                    {val.created_date}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {isLoadingMore && (
                <div className="text-center py-3 text-muted" style={{ fontSize: '14px' }}>
                    Loading more...
                </div>
            )}
        </div>
    );
};

export default RedeemModal;
